/**
 * Send custom event with detailed data
 */
export const sendEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data || null });
    window.dispatchEvent(event);
};
